import { useContext } from 'react'

import { RoundTableContext } from '../../context/RoundTableContext'
import { RoundTableText } from '../roundTableText/RoundTableText'

import styles from './RoundTableInfo.module.scss'

export const RoundTableInfo = () => {
  const { ready } = useContext(RoundTableContext)
  return ready ? (
    <div className={styles.info} role="status">
      <i className="kbase kbase-lvl-session" aria-hidden />
      <div>
        <div className={styles.infoTitle}>
          <RoundTableText name="infoTitle" />
        </div>
        <RoundTableText name="info" />
      </div>
    </div>
  ) : null
}
